'use client';

import { CloseIcon } from '@/components/icons/menu/CloseIcon';
import { OpenIcon } from '@/components/icons/menu/OpenIcon';

export function HamburgerMenu({
  isOpen,
  onClick,
}: {
  isOpen: boolean;
  onClick: () => void;
}) {
  return (
    <button
      aria-expanded={isOpen}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      className="xl:hidden"
      onClick={onClick}
      type="button"
    >
      {isOpen ? (
        <CloseIcon
          aria-hidden="true"
          className="h-8 w-8"
          desc="Close menu icon"
          title="Close Menu"
        />
      ) : (
        <OpenIcon
          aria-hidden="true"
          className="h-8 w-8"
          desc="Open menu icon"
          title="Open Menu"
        />
      )}
    </button>
  );
}
